import { React, useEffect, useState } from "react";
import Chess960Board from "../components/Chess960Board";
import GameDetails from "../components/GameDetails";
import Sidebar from "../components/Sidebar";
import { useGlobalContext } from "../context";
import { generateStartPosition } from "../helpers/chess960Helpers";

const Chess = require("chess.js");
let chess = new Chess();

const PlayClassic = () => {
  const { setIsGameOver, piecesColor, setNewChess960Game } = useGlobalContext();

  useEffect(() => {
    setIsGameOver(false);
    chess.load(generateStartPosition());
    setNewChess960Game(true);
  }, []);

  const [casltingFigures, setCasltingFigures] = useState({
    rook1: "",
    rook2: "",
    king: "",
  });
  useEffect(() => {
    const notation = ["a", "b", "c", "d", "e", "f", "g", "h"];
    let color;
    piecesColor ? (color = "1") : (color = "8");
    let rooks = [];
    let king;
    chess.board()[0].map((item, index) => {
      if (item.type === "r") {
        rooks.push(index);
      } else if (item.type === "k") {
        king = index;
      }
      setCasltingFigures({
        rook1: notation[rooks[0]] + color,
        rook2: notation[rooks[1]] + color,
        king: notation[king] + color,
      });
      return;
    });
  }, []);

  return (
    <main>
      <div className="section">
        <Chess960Board chess={chess} casltingFigures={casltingFigures} />
        <GameDetails chess={chess} chess960={true} />
      </div>
      <Sidebar />
    </main>
  );
};

export default PlayClassic;
